import React, { useState, useRef, Fragment, useEffect } from 'react';
import './rte.scss';
import { Editor } from '@tinymce/tinymce-react';
import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/content.min.css';
import 'tinymce/skins/content/default/content.min.css';
import 'tinymce/models/dom/model';
import ReactHtmlParser from 'react-html-parser';
import * as DOMPurify from 'dompurify';
import { observer } from 'mobx-react';

export const RTEComponent = observer((props: IRTEProps) => {
  const editorRef: any = useRef(null);
  const handleEditorChange = (content, editor) => {
    props.saveCallback(content);
  };
  const handleOnBlur = props.onBlur;
  return (
    <Fragment>
      <Editor
        initialValue={props.initialValue ? props.initialValue : ''}
        onInit={(evt, editor) => {
          editorRef.current = editor;
        }}
        init={{
          promotion: false,
          statusbar: false,
          skin: false,
          content_css: false,
          resize: false,
          menubar: false,
          plugins: ['lists', 'image'],
          toolbar: 'bold italic underline | bullist numlist | image',
          images_file_types: 'jpg,svg,png,webp',
          file_picker_types: 'image',
          file_picker_callback: (cb, value, meta) => {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');

            input.addEventListener('change', (e) => {
              const file = (e.target as any).files[0];

              const reader = new FileReader();
              reader.addEventListener('load', () => {
                /*
                                  Note: Now we need to register the blob in TinyMCEs image blob
                                  registry. In the next release this part hopefully won't be
                                  necessary, as we are looking to handle it internally.
                                */
                const id = 'blobid' + new Date().getTime();
                const blobCache = editorRef.current.editorUpload.blobCache;
                // const blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                const base64 = (reader.result! as string).split(',')[1];
                const blobInfo = blobCache.create(id, file, base64);
                blobCache.add(blobInfo);

                /* call the callback and populate the Title field with the file name */
                cb(blobInfo.blobUri(), { title: file.name });
              });
              reader.readAsDataURL(file);
            });

            input.click();
          },
        }}
        value={props.contentString}
        onEditorChange={handleEditorChange}
        onBlur={handleOnBlur}
      />
    </Fragment>
  );
});

/**
 * Rich Text Display Component.
 *
 * Used to display previously exported Rich Text Editor HTML strings via react-html-parser.
 * @param props
 * @returns
 */
export const RTDComponent = observer((props: IRTDProps) => {
  const sanitizedHtml = DOMPurify.sanitize(props.htmlString);
  console.log('removed by dom purify: ', DOMPurify.removed);
  return <Fragment>{ReactHtmlParser(sanitizedHtml)}</Fragment>;
});

interface IRTEProps {
  saveCallback: (...args) => void;
  initialValue?: string;
  contentString: string;
  onBlur?:(e)=>void;
}
interface IRTDProps {
  htmlString: string;
}
